import { z } from "zod";
import {
  CITY,
  EMAIL,
  GEOGRAPHICAL_REGION,
  MOBILE,
  NAME,
  ROLE,
  STATE,
  STATUS
} from "../consts";

export const schema = z.object({
  [NAME]: z.string().optional(),
  [EMAIL]: z.string().optional(),
  [MOBILE]: z.string().optional(),
  [ROLE]: z.string().optional(),
  [GEOGRAPHICAL_REGION]: z.string().optional(),
  [STATE]: z.string().optional(),
  [CITY]: z.string().optional(),
  [STATUS]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
